<template>
    <div>

        <table class="table table-warning table-decision">
            <thead>
            <tr>
                <th scope="col">Decision</th>
                <th scope="col">
                  <span v-if="local.matrix.confirmed == 0">Suggested score</span>
                  <span v-else>Confirmed Scores</span>
                </th>
                <th scope="col">
                  <button
                      v-if="!adjusted"
                      class="btn btn-outline-secondary"
                      @click="adjustScores">
                    <i class="fas fa-check-circle"></i> Adjust decision score</button>
                </th>
            </tr>
            </thead>
            <tr v-if="local.considerations.length>0 && local.decisions.length>0"
                v-for="(decision, decisionIndex) in decisionTable"
                v-bind:class="{ 'active': (decisionIndex == getTestDecision) }">

                <td>{{decision.name}}</td>
                <td>
                  <span v-if="local.matrix.confirmed == 0">
                     {{decision.label}}
                  </span>
                  <span v-else>

                      <div v-if="decision.sequence ==0 || decision.sequence == 1000">
                            {{decision.label_confirmed}}
                            <span v-if="decision.sequence == 0">{{decision.confirmed_lower_score}}</span>
                            <span v-if="decision.sequence == 1000">{{decision.confirmed_upper_score}}</span>
                      </div>

                      <div v-if="decision.sequence != 0 && decision.sequence != 1000">
                        <span>{{decision.confirmed_lower_score}}</span>
                         to
                        <span>{{decision.confirmed_upper_score}}</span>
                      </div>

                  </span>
                </td>
                <td class="w-25">
                  <div v-show="showConfirm" v-if="!adjusted">

                      <div v-if="decision.sequence ==0 || decision.sequence == 1000" class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">
                            {{decision.label_confirmed}}
                          </div>
                        </div>
                        <input v-if="decision.sequence == 0" type="text" class="form-control" v-model="decision.confirmed_lower_score">
                        <input v-if="decision.sequence == 1000" type="text" class="form-control" v-model="decision.confirmed_upper_score">
                      </div>


                      <div v-if="decision.sequence != 0 && decision.sequence != 1000" class="input-group">
                        <input v-model="decision.confirmed_lower_score" type="text" class="form-control">
                        <div class="input-group-prepend">
                          <div class="input-group-text">to</div>
                        </div>
                        <input v-model="decision.confirmed_upper_score" type="text" class="form-control">
                      </div>
                  </div>
                </td>
            </tr>
          <tr v-show="showConfirm">
            <td colspan="3" class="text-right">
              <button class="btn btn-dark" v-if="local.matrix.confirmed && adjusted" @click="undoConfirmScore">Undo</button>
              <button class="btn btn-primary" v-else @click="updateConfirmScore">Update decision scores</button>
            </td>
          </tr>
        </table>
    </div>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';

    export default {
        props: ['scenarioTesting', 'maxScore', 'testScore'],
        name: "CreateDecisionTable",

        data() {
            return {
                local: {
                    matrix: [],
                    considerations: [],
                    decisions: [],
                },
                showConfirm: false,
                adjusted: false,
            };
        },


        methods: {
            ...mapMutations('data', [
                'commitConsiderations',
                'commitDecisionTable',
                'commitScoreCard',
                'commitMatrix',
            ]),

          adjustScores: function () {
              this.showConfirm = !this.showConfirm
              //this.$emit('clicked', 'confirmed')
          },

          updateConfirmScore: function () {
              this.adjusted = true
              this.local.matrix.confirmed = 1
              this.commitMatrix(this.local.matrix);
          },

          undoConfirmScore: function () {
              this.adjusted = false
              this.local.matrix.confirmed = 0
              this.commitMatrix(this.local.matrix);
          }
        },

        mounted() {
            this.local.matrix = { ...this.dataMatrix };
            this.local.considerations = [...this.dataConsiderations];
            this.local.decisions = [...this.dataDecisions];

            if(typeof(this.$store.state.data.matrix.scoreCard.maxScore) == 'undefined') {
                console.log('undefined')
                //this.commitScoreCard(this.risk_score); //set the default risk rating
            }
            //this.local.scoreCard = {...this.dataScoreCard}
        },

        computed: {
            ...mapState('data', {
                dataMatrix: state => state.matrix,
                dataConsiderations: state => state.matrix.considerations,
                dataDecisions: state => state.matrix.decisions,
                dataScoreCard: state => state.matrix.scoreCard,
            }),

            ...mapState('config', [
                'scoreRating',
            ]),

            decisionTable: function () {

                //how many decisions?
                //what is the risk rating? create json object for risk rating?
                //decide tolerance values based on number of decisions using given table

                let decisionCount = this.local.decisions.length
                let scoreCard = {}
                if(!(_.isUndefined(this.scoreRating.decisions[decisionCount]))) {

                    let tolerance = this.scoreRating.decisions[decisionCount].tolerance
                    let riskRating = this.dataScoreCard.riskRating
                    let maxScore = this.maxScore

                    scoreCard = {
                        maxScore: maxScore,
                        riskRating: this.riskRating
                    }

                    let lower_score = Math.round(maxScore*tolerance[riskRating].lower)
                    let upper_score = Math.round(maxScore*tolerance[riskRating].upper)
                    let lower_intermediate = Math.round(maxScore*tolerance[riskRating].lower_intermediate)
                    let upper_intermediate = Math.round(maxScore*tolerance[riskRating].upper_intermediate)

                    switch (decisionCount) {
                        case 2:
                            this.local.decisions[0].lower_score = lower_score
                            this.local.decisions[0].label = 'More than ' + lower_score
                            this.local.decisions[0].confirmed_lower_score = this.local.decisions[0].confirmed_lower_score ?? lower_score
                            this.local.decisions[0].label_confirmed = 'More than '

                            this.local.decisions[1].upper_score = upper_score
                            this.local.decisions[1].label = 'Less than or equal ' + upper_score
                            this.local.decisions[1].confirmed_upper_score = this.local.decisions[1].confirmed_upper_score ?? upper_score
                            this.local.decisions[1].label_confirmed = 'Less than or equal '

                            break;

                        case 3:
                            this.local.decisions[0].lower_score = lower_score
                            this.local.decisions[0].label = 'More than ' + lower_score
                            this.local.decisions[0].confirmed_lower_score = this.local.decisions[0].confirmed_lower_score ?? lower_score
                            this.local.decisions[0].label_confirmed = 'More than '

                            this.local.decisions[1].lower_score = upper_score
                            this.local.decisions[1].upper_score = lower_score
                            this.local.decisions[1].label =  upper_score + ' to ' + lower_score

                            this.local.decisions[1].confirmed_lower_score = this.local.decisions[1].confirmed_lower_score ?? upper_score
                            this.local.decisions[1].confirmed_upper_score = this.local.decisions[1].confirmed_upper_score ?? lower_score

                            this.local.decisions[2].upper_score = upper_score
                            this.local.decisions[2].label=  'Less than ' + upper_score
                            this.local.decisions[2].confirmed_upper_score =  this.local.decisions[2].confirmed_upper_score ?? upper_score
                            this.local.decisions[2].label_confirmed =  'Less than '

                            break;

                        case 4:
                            this.local.decisions[0].lower_score = lower_score
                            this.local.decisions[0].label = 'More than ' + lower_score
                            this.local.decisions[0].confirmed_lower_score = this.local.decisions[0].confirmed_lower_score ?? lower_score
                            this.local.decisions[0].label_confirmed = 'More than '

                            this.local.decisions[1].lower_score = lower_intermediate
                            this.local.decisions[1].upper_score = lower_score
                            this.local.decisions[1].label = lower_intermediate + ' to ' + lower_score

                            this.local.decisions[1].confirmed_lower_score = this.local.decisions[1].confirmed_lower_score ?? lower_intermediate
                            this.local.decisions[1].confirmed_upper_score = this.local.decisions[1].confirmed_upper_score ?? lower_score

                            this.local.decisions[2].lower_score = upper_score
                            this.local.decisions[2].upper_score = upper_intermediate
                            this.local.decisions[2].label = upper_score + ' to ' + upper_intermediate

                            this.local.decisions[2].confirmed_lower_score = this.local.decisions[2].confirmed_lower_score ?? upper_score
                            this.local.decisions[2].confirmed_upper_score = this.local.decisions[2].confirmed_upper_score ?? upper_intermediate

                            this.local.decisions[3].upper_score = upper_score
                            this.local.decisions[3].label = 'Less than ' + upper_score
                            this.local.decisions[3].confirmed_upper_score = this.local.decisions[3].confirmed_upper_score ?? upper_score
                            this.local.decisions[3].label_confirmed = 'Less than '
                            break;
                    }
                }

                return this.local.decisions //we just return max score
            },

          getTestDecision: function () {
                const vm = this

                return _.findIndex(this.local.decisions, function(decision){
                  return (
                      (decision.lower_score < vm.testScore && decision.upper_score == null) ||
                      (decision.lower_score >= vm.testScore && decision.upper_score != null && decision.upper_score <= vm.testScore) ||
                      (decision.upper_score > vm.testScore && decision.lower_score == null)
                  )
                });
            },

            scoreAdjusted: function () {
                return this.local.matrix.confirmed
            }
        },
    }
</script>

<style scoped>
    .table-decision {
        background-color: #fffde9;;
    }

    .table-decision tr.active {
        background-color: #fff0c4;
    }
</style>